<script>
export default {
  name: "AppEmptyResult",

  props: {
    type: { type: String, default: '' },
    title: { type: String, default: '' },
    captions: { type: Array, default: () => [] },
    minHeight: { type: String, default: '500px' },
  },
}
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-center align-items-center" :style="{ minHeight: minHeight }">
        <div class="text-center">
          <img
            v-if="type === 'users'"
            src="/assets/images/no-users.png"
            alt="people in chat bubbles"
            width="239px"
            height="77px"
          >
          <img
            v-else-if="type === 'results'"
            src="/assets/images/no-results.png"
            alt="man looking at search bar"
            width="146px"
            height="146px"
          >
          <img
            v-else-if="type === 'campaign'"
            src="/assets/images/no-campaign.png"
            alt="announcement"
            width="239px"
            height="77px"
          >
          <h3 class="font-size-22 mt-4 pt-1" :style="{ color: '#495057' }">{{ title }}</h3>
          <div class="mt-3" :style="{ color: '#74788D' }">
            <p
              class="m-0 p-0"
              v-for="(caption, key) in captions"
              :key="key"
            >
              {{ caption }}
            </p>
          </div>
          <slot name="action"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>